import { i18n } from "@lingui/core";
import { setUserLocale } from "../amplitude";
import { messages } from "./messages";
import { plurals } from "./plurals";
import { getSelectedLocale } from "./store";

i18n.loadLocaleData(plurals);
i18n.load(messages);

const DEFAULT_LOCALE = "en";
const initial = getSelectedLocale() ?? DEFAULT_LOCALE;
i18n.activate(initial);

setUserLocale(initial);
